// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2k6uY","infoCard":"styles_infoCard__2AV_0","delete":"styles_delete__32Mcb"};